import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { CreateTarrifResponse, TarrifConfigurationResponse } from '../../types/records/tariff-configuration';
import { CurrentTariffResponse } from '../../types';

export const tariffConfigurationEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'prepaidEngineApi'
  >
) => ({
  getAllTarrifs: builder.query<TarrifConfigurationResponse[], void>({
    query: () => ({
      url: `prepaid-engine/mdms_api/list/tariffs`,
      method: 'GET'
    }),
     providesTags: ['getAllTarrifs']
  }),

    createTarrifData: builder.mutation<'', {data:Partial<CreateTarrifResponse>[]}>({
      query: (data) => ({
        url: `/prepaid-engine/tariff_data/many`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['getAllTarrifs','getTariffDataByConsumerType','getTariffBySuppyTypeCode']
    }),
    getTariffDropdowns: builder.query<Record<string, string[]>, void>({
      query: () => ({
        url: `prepaid-engine/mdms_api/tariff/dropdowns`,
        method: 'GET',
      }),
      providesTags: ['getTariffDropdowns'],
    }),
    getTariffByConsumerCategory: builder.query<CreateTarrifResponse[], string>({
      query: (params) => ({
        url: `prepaid-engine/tariff_data/consumer/${params}`,
        method: 'GET',
      }),
      providesTags: ['getTariffDataByConsumerType']
    }),
      getTariffBySuppyTypeCode: builder.query<CurrentTariffResponse, string>({
    query: (param) => ({
      url: `/prepaid-engine/v2/tariff_info${param}`
    }),
     providesTags: ['getTariffBySuppyTypeCode']
  }),
    deleteTariffData: builder.mutation<'', number>({
      query: (id) => ({
        url: `/prepaid-engine/tariff_data/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['getAllTariffs']
    }),
    updateTariffData: builder.mutation<'', { data: Partial<CreateTarrifResponse>[] ; id: number}>({
        query: ({data, id}) => ({
          url: `/prepaid-engine/tariff_data/${id}`,
          method: 'POST',
          body: data
        }),
        invalidatesTags: ['getAllTariffs']
      }),
      
  });
